import type { GoogleMapProps as GMProps } from '@react-google-maps/api';
import clsx from 'clsx';
import { Suspense, lazy, useContext } from 'react';
import { GoogleMapsContext } from './GoogleMapsProvider';

interface GoogleMapProps extends GMProps {
	width: `w-${string}`;
	height: `h-${string}`;
	markerSize?: number;
	location: {
		lat: number;
		lng: number;
	};
	className?: string;
}

const GM = lazy(() => import('@react-google-maps/api').then(m => ({ default: m.GoogleMap })));
const MarkerF = lazy(() => import('@react-google-maps/api').then(m => ({ default: m.Marker })));

export function GoogleMap({
	location,
	zoom = 17,
	width,
	height,
	markerSize = 25,
	className = 'rounded-3xl border border-blue overflow-hidden',
	...MapProps
}: GoogleMapProps) {
	const { isLoaded } = useContext(GoogleMapsContext);

	return (
		<div className={clsx(width, height, className)}>
			{isLoaded ? (
				<Suspense fallback={null}>
					<GM
						options={{ mapId: '7f4a54f013eb304' }}
						mapContainerStyle={{ width: '100%', height: '100%' }}
						center={location}
						zoom={zoom}
						{...MapProps}
					>
						<MarkerF
							position={location}
							icon={{
								url: '/images/pin.png',
								scaledSize: new window.google.maps.Size(markerSize, markerSize),
							}}
						/>
					</GM>
				</Suspense>
			) : (
				<div className="flex items-center justify-center w-full h-full">
					<div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-blue"></div>
				</div>
			)}
		</div>
	);
}
